import type { VoidFunctionComponent } from 'react';

type Props = {
  depthMessages: string[]
};

/**
 * Display the number of direct and transitive dependencies in a formatted message.
 *
 * example: This issue exists in a direct dependency of 6 projects and in a transitive dependency of 5 projects
 */
const DependencyDepthMessage: VoidFunctionComponent<Props> = ({ depthMessages }) => {
  const depthMessage = depthMessages.map((message, index) => (
    <>
      <span className="bold">{message}</span>
      {index < depthMessages.length - 1 ? ' and in a ' : ''}
    </>
  ));

  return (
    <div>
      This issue exists in a {depthMessage}.
    </div>
  );
};

export default DependencyDepthMessage;
